import { render, staticRenderFns } from "./NewFieldModal.vue?vue&type=template&id=6ed87092&"
import script from "./NewFieldModal.vue?vue&type=script&lang=js&"
export * from "./NewFieldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports